export default __webpack_public_path__ + "static/sage-snap-frame-mobile-f8816d6a249a6a83a4a3faae08d55282.gif";